import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import EduExpContent from './EduExpContent';
import Eduexpimg from './ui/eduexpimg';
import './EduExp.css';
import Particle from '../Particle';
const resumeleft = {
  left: {
    title: ['Experience'],
    data: [
      {
        title: 'Software Development Engineer',
        subtitle: 'Asint, Inc',
        location: 'Houston, Texas',
        date: 'Nov 2023 - present',
        content: [
          'Improved the user experience of 5+ UI components by writing clean code with SAPUI5, adhering to best practices in web application architecture and SAP Fiori design principles.',
          'Developed 10+ RESTful APIs and scalable microservices using SAP BTP Cloud Platform and SAP Gateway, significantly enhancing application functionality, and optimized SAP S/4HANA database schemas to improve data storage efficiency.',
        ],
      },
      {
        title: 'Associate Software Engineer',
        subtitle: 'Incture Technologies Pvt. Ltd',
        location: 'Benguluru, India',
        date: 'Oct 2020 - July 2022',
        content: [
          ' Developed business web applications that involved web frameworks SAP UI5, and Angular.',
          ' Consistently improved and developed bug fixes and patch sets for existing web applications, resulting in a 60% reduction in application downtime and an 80% increase in user satisfaction.',
          ' Implementing advanced data visualization tools like PlotlyJS graphs and ArcGIS Geographical Maps with oil well data from WebSockets led to a 25% reduction in operational costs and a 30% improvement in remote assistance efficiency.',
          'Effectively incorporated SAP business rules into five business applications within the SAP Cloud Platform, streamlining processes and enhancing decision-making capabilities by 40%.',
          'Implemented Single Sign-On (SSO) authentication method, seamlessly enabling 1200+ users to authenticate securely across multiple client applications.',
          ' Crafted a custom theme using SAP Fiori Theme Designer to elevate the user experience of the SAP Fiori Launchpad.',
          'Transformed the default SAP login page into a tailor-made, branded login experience specifically designed for the client.',
          'Implemented custom drag-and-drop functionality within SAP Fiori Elements, seamlessly integrating it into a SAPUI5 application for enhanced user interaction and efficiency.',
        ],
      },
      {
        title: 'Trainee',
        subtitle: 'Incture Technologies Pvt. Ltd',
        location: 'Benguluru, India',
        date: 'June 2020 - Sep 2020',
        content: [
          'Developed a visitor management product using JAVA & SAPUI5 to help manage visitors within a department',
          'Implemented Authentication and database using SQLite & REST API and later upgraded it to Firebase DB & Auth.',
          'Gained expertise in REST APIs, User Interface Design(UI), Front End Design, enhancing application logic, JSON parsing',
          'By adhering to the Agile methodology throughout the project development process and consistently focusing on testing and debugging, we achieved a 25% reduction in post-deployment bugs and a 20% faster feature rollout.',
          'Received appreciation for my efforts and contribution as an intern, and I was offered full-time employment.',
        ],
      },
    ],
  },
};

const resumeright = {
  right: [
    {
      title: ['Education'],
      data: [
        {
          title: 'Masters in Computer Science',
          subtitle: 'The George Washington University',
          location: 'Washington DC',
          date: '2022 - 2022',
          content: ['GPA: 3.78'],
        },
        {
          title: 'Bachelor of Technology in Electronics and Communication',
          subtitle: 'Gayatri Vidya Parishad College of Engineering',
          location: 'Visakhapatnam, India',
          date: '2016 - 2020',
          content: ['GPA: 3.4/4'],
        },
      ],
    },
  ],
};
const EduExp = () => {
  return (
    <Container fluid className="resume1-section">
      <Particle />
      <Container>
        <div className="basic-projects">
          <div className="projects-heading-div">
            <div className="projects-heading-img-div">
              <Eduexpimg />
            </div>
            <div className="projects-heading-text-div">
              <h1 className="projects-heading-text">
                My Experience & Education
              </h1>
              {/* <p className="projects-header-detail-text subTitle">description</p> */}
            </div>
          </div>
        </div>
        <Row className="resume">
          <div className="heading-div">
            <div>
              <Col className="resume-left">
                {resumeleft.left.title.map((head) => {
                  return (
                    <>
                      <h3 className="resume-title">{head}</h3>
                      {resumeleft.left.data.map((res) => {
                        return (
                          <EduExpContent
                            title={res.title}
                            subtitle={res.subtitle}
                            date={res.date}
                            content={res.content}
                            location={res.location}
                          ></EduExpContent>
                        );
                      })}
                    </>
                  );
                })}
              </Col>
            </div>
            <div>
              <Col className="resume-right">
                {resumeright.right.map((head) => {
                  return (
                    <>
                      <h3 className="resume-title">{head.title}</h3>
                      {head.data.map((info) => {
                        return (
                          <EduExpContent
                            title={info.title}
                            subtitle={info.subtitle}
                            date={info.date}
                            content={info.content}
                            location={info.location}
                          ></EduExpContent>
                        );
                      })}
                    </>
                  );
                })}
              </Col>
            </div>
          </div>
        </Row>
      </Container>
    </Container>
  );
};

export default EduExp;
